// extracted by mini-css-extract-plugin
export default {"title":"u0pek","bgc":"xTkgr","hidden":"aDBOY"};